<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>部门
          </div>
          <div style="overflow: auto; height: calc(100vh - 179px)">
            <es-org-tree @clickByOrg="queryAssetList"
                         @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>设备
          </div>
          <div class="es-op-box">
            <el-input placeholder="请输入设备名称"
                      v-model="queryObj.keyWord"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadAssetList();
                }
              ">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-select style="float: left"
                       class="query"
                       size="small"
                       v-model="queryObj.typeId"
                       placeholder="请选择设备类型"
                       clearable
                       filterable
                       @clear="
                () => {
                  this.queryObj.pageNum = 1;
                  delete this.queryObj.typeId;
                  loadAssetList();
                }
              "
                       @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadAssetList();
                }
              ">
              <el-option v-for="item in types"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-select style="float: left"
                       class="query"
                       size="small"
                       v-model="queryObj.systemId"
                       placeholder="请选择系统专业"
                       clearable
                       filterable
                       @clear="
                () => {
                  this.queryObj.pageNum = 1;
                  delete this.queryObj.systemId;
                  loadAssetList();
                }
              "
                       @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadAssetList();
                }
              ">
              <el-option v-for="item in systems"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-select style="float: left"
                       class="query"
                       size="small"
                       v-model="queryObj.state"
                       placeholder="请选择设备状态"
                       clearable
                       filterable
                       @clear="
                () => {
                  this.queryObj.pageNum = 1;
                  delete this.queryObj.state;
                  loadAssetList();
                }
              "
                       @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadAssetList();
                }
              ">
              <el-option v-for="item in states"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right"><i v-if="item.id == 1"
                     class="el-icon-font el-icon-qiyong"
                     style="color: #67c23a"></i>
                  <i v-if="item.id == 2"
                     class="el-icon-font el-icon-tingyong-zanting"
                     style="color: red"></i></span>
              </el-option>
            </el-select>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right: 6px"
                       @click="add_init">新增</el-button>
            <es-delete @del="del()"
                       type="button"></es-delete>
          </div>
          <el-table :data="pageData.list"
                    ref="assetTable"
                    show-overflow-tooltip
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loading">
            <el-table-column type="selection"
                             width="40"
                             align="center">
            </el-table-column>
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="name"
                             label="设备名称"> </el-table-column>
            <el-table-column prop="code"
                             label="设备编码"> </el-table-column>
            <el-table-column prop="typeName"
                             label="设备类型">
            </el-table-column>
            <el-table-column prop="manufacturerName"
                             label="生产厂家">
            </el-table-column>
            <el-table-column prop="modelName"
                             label="设备型号">
            </el-table-column>
            <el-table-column prop="systemName"
                             label="系统专业">
            </el-table-column>
            <el-table-column prop="orgName"
                             label="所属部门"> </el-table-column>
            <el-table-column prop="areaName"
                             label="所属区域">
            </el-table-column>
            <el-table-column width="50"
                             align="center"
                             label="状态">
              <template slot-scope="scope">
                <font v-if="scope.row.state == 1"
                      style="color: #67c23a">启用</font>
                <font v-if="scope.row.state == 2"
                      style="color: red">停用</font>
              </template>
            </el-table-column>

            <el-table-column width="50"
                             align="center"
                             label="重点维保">
              <template slot-scope="scope">
                <font v-if="scope.row.isImportant == 0">否</font>
                <font v-if="scope.row.isImportant == 1"
                      style="color: red">是</font>
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             width="150"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="附件"
                         @click="edit_file(scope.row)"
                         type="primary"><i class="el-icon-upload"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false"
                         title="详情"
                         @click="view(scope.row)"
                         type="success"><i class="el-icon-font el-icon-view"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false"
                         title="编辑"
                         @click="edit_init(scope.row)"
                         type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="del(scope.row.id)"
                           :key="scope.row.id"
                           type="icon"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="
                (cpage) => {
                  this.queryObj.pageNum = cpage;
                  this.loadAssetList();
                }
              ">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogFileVisible"
               width="800px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>附件编辑
      </span>
      <div style="margin-top: 10px"
           v-loading="loadingFile">
        <el-divider><span style="color: #409eff">文件附件</span></el-divider>
        <el-upload :action="getUploadAction()"
                   accept=".doc,.xls,.ppt,.pdf,.docx,.xlsx,.pptx,.pptm"
                   :beforeUpload="beforeUpload"
                   :headers="{ token: this.$store.getUser().token, platform: 'web' }"
                   :show-file-list="false"
                   :file-list="assetFileList"
                   :on-success="handleSuccess"
                   :on-error="handleError"
                   :on-exceed="handleExceed"
                   :data="{ busCode: 'assetType', type: 'files' }">
          <el-button style="float: right"
                     size="mini"
                     type="primary">附件</el-button>
        </el-upload>
        <el-table :data="assetFileList"
                  ref="assetTypeFileTable"
                  border
                  stripe
                  size="mini"
                  width="100%">
          <el-table-column type="index"
                           label="序号"
                           width="50"
                           align="center">
          </el-table-column>
          <el-table-column prop="name"
                           width=""
                           label="文件名称">
          </el-table-column>
          <el-table-column prop="size"
                           width=""
                           label="文件大小(KB)">
            <template slot-scope="scope">
              {{ (scope.row.size / 1024).toFixed(1) }}
            </template>
          </el-table-column>
          <el-table-column width="80"
                           label="操作"
                           align="center">
            <template slot-scope="scope">
              <el-link :underline="false"
                       title="附件"
                       @click="downFile(scope.row)"
                       type="primary"><i class="el-icon-download"></i></el-link>
              <el-divider direction="vertical"></el-divider>
              <es-delete @del="delFile(scope.row)"
                         :key="scope.row.id"
                         type="icon"></es-delete>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <es-img :info="assetInfo"
              :fileList="fileList"
              busCode="asset"
              dataUrl="/base/asset/edit_attach_imgs"
              type="edit"
              :max="20"
              tip="图片大小不能超过5MB。图片数量不能超过20张。"
              @insertAttachImgs="
          (attachImgs) => {
            this.$set(this.assetInfo, 'attachImgs', attachImgs);
          }
        "></es-img>
    </el-dialog>
    <!--编辑设备-->
    <el-dialog :visible.sync="editVisible"
               @closed="
        () => {
          this.$refs['assetForm'].clearValidate();
          this.fileList = [];
        }
      "
               width="1200px"
               style="padding-top: 0px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑设备
      </span>
      <div v-loading="editLoading">
        <el-form :model="assetInfo"
                 :inline="true"
                 :rules="rules"
                 size="mini"
                 label-position="right"
                 label-width="150px"
                 ref="assetForm">
          <el-form-item prop="name"
                        label="设备名称">
            <el-input v-model="assetInfo.name"
                      placeholder="请输入设备名称"
                      style="width: 200px"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="code"
                        label="设备编码">
            <el-input v-model="assetInfo.code"
                      placeholder="请输入设备编码"
                      style="width: 200px"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="orgId"
                        label="所属部门">
            <el-cascader ref="orgId"
                         v-model="assetInfo.orgId"
                         :show-all-levels="false"
                         :props="{ value: 'id', checkStrictly: true }"
                         :options="orgTree"
                         filterable
                         @change="
                () => {
                  this.loadAreaListAll();
                  this.$set(this.assetInfo, 'areaId', null);
                }
              "
                         style="width: 200px"></el-cascader>
          </el-form-item>
          <el-form-item prop="areaId"
                        label="所属区域">
            <el-select ref="areaSelect"
                       style="width: 200px"
                       v-model="assetInfo.areaId"
                       placeholder="请选择所属区域"
                       clearable
                       filterable>
              <el-option v-for="item in areas"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="systemId"
                        label="所属系统">
            <el-select ref="systemSelect"
                       style="width: 200px"
                       v-model="assetInfo.systemId"
                       placeholder="请选择所属系统"
                       clearable
                       filterable>
              <el-option v-for="item in systems"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="typeId"
                        label="设备类型">
            <el-select ref="typeSelect"
                       style="width: 200px"
                       v-model="assetInfo.typeId"
                       placeholder="请选择设备类型"
                       @change="
                () => {
                  this.loadModelListAll();
                  this.loadExtendListAll();
                  this.$set(this.assetInfo, 'modelId', null);
                }
              "
                       clearable
                       filterable>
              <el-option v-for="item in types"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="manufacturerId"
                        label="生产厂家">
            <el-select ref="manufacturerSelect"
                       style="width: 200px"
                       v-model="assetInfo.manufacturerId"
                       placeholder="请选择生产厂家"
                       @change="
                () => {
                  this.loadModelListAll();
                  this.$set(this.assetInfo, 'modelId', null);
                }
              "
                       clearable
                       filterable>
              <el-option v-for="item in factories"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="modelId"
                        label="设备型号">
            <el-select ref="modelSelect"
                       style="width: 200px"
                       v-model="assetInfo.modelId"
                       placeholder="请选择设备型号"
                       clearable
                       filterable>
              <el-option v-for="item in models"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="proDate"
                        label="出厂日期">
            <el-date-picker v-model="assetInfo.proDate"
                            value-format="yyyy-MM-dd"
                            type="date"
                            clearable
                            :editable="false"
                            style="width: 200px"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="life"
                        label="理论寿命（月）">
            <el-input-number v-model="assetInfo.life"
                             placeholder="理论寿命（月）"
                             controls-position="right"
                             style="width: 200px"
                             :min="1"
                             :max="360"></el-input-number>
          </el-form-item>
          <el-form-item prop="useStart"
                        label="投用日期">
            <el-date-picker v-model="assetInfo.useStart"
                            type="date"
                            value-format="yyyy-MM-dd"
                            clearable
                            :editable="false"
                            style="width: 200px"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item prop="mtcFactoryId"
                        label="运维厂家">
            <el-select ref="mtcFactorySelect"
                       style="width: 200px"
                       v-model="assetInfo.mtcFactoryId"
                       placeholder="请选择运维厂家"
                       clearable
                       filterable>
              <el-option v-for="item in factories"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mtcStart"
                        label="运维开始日期">
            <el-date-picker v-model="assetInfo.mtcStart"
                            type="date"
                            value-format="yyyy-MM-dd"
                            clearable
                            :editable="false"
                            style="width: 200px"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="mtcEnd"
                        label="运维结束日期">
            <el-date-picker v-model="assetInfo.mtcEnd"
                            type="date"
                            value-format="yyyy-MM-dd"
                            clearable
                            :editable="false"
                            style="width: 200px"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="state"
                        label="设备状态">
            <el-radio-group v-model="assetInfo.state"
                            style="width: 200px">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">停用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="useEnd"
                        label="停用日期">
            <el-date-picker v-model="assetInfo.useEnd"
                            type="date"
                            value-format="yyyy-MM-dd"
                            clearable
                            :editable="false"
                            style="width: 200px"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="isImportant"
                        label="重点维保">
            <el-radio-group v-model="assetInfo.isImportant"
                            style="width: 200px">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item prop="price"
                        label="资产总额">
            <el-input-number placeholder="请输入资产总额"
                             style="width: 200px"
                             clearable
                             v-model="assetInfo.price"
                             :precision="4"
                             :step="0.1"
                             :min="0">
            </el-input-number>
          </el-form-item>

          <el-form-item prop="lnglat"
                        label="经纬度">
            <el-input placeholder="请输入经纬度"
                      style="width: 200px"
                      v-model="assetInfo.lnglat">
              <i slot="suffix"
                 class="el-icon-location-outline"
                 style="cursor: pointer"
                 @click="showMap"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="assetLocation"
                        label="设备位置">
            <el-input v-model="assetInfo.assetLocation"
                      placeholder="请输入设备位置"
                      style="width: 200px"
                      clearable>
            </el-input>
          </el-form-item>
          <!-- 扩展属性 -->
          <es-extend :extendMetaData="extendMetaData"
                     :extendData="extendData"
                     idName="assetId"
                     :idValue="assetInfo.id"
                     type="edit"
                     @changeData="insertExtendData">
          </es-extend>
        </el-form>
      </div>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitAsset()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>

    <!--查看详情-->
    <el-dialog :visible.sync="viewVisible"
               width="1200px"
               style="padding-top: 0px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>设备详情
      </span>

      <el-tabs v-model="activeName"
               type="card">
        <el-tab-pane label="基本信息"
                     name="first">
          <div v-loading="viewLoading">
            <el-descriptions :column="3"
                             style="cursor: pointer; margin-bottom: 12px"
                             size="mini"
                             border>
              <el-descriptions-item label="设备名称"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.name!=''&&assetInfo.name!=null">{{
                assetInfo.name
              }}</el-descriptions-item>
              <el-descriptions-item label="设备编码"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.code!=''&&assetInfo.code!=null">{{
                assetInfo.code
              }}</el-descriptions-item>
              <el-descriptions-item label="所属部门"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.orgName!=''&&assetInfo.orgName!=null">{{
                assetInfo.orgName
              }}</el-descriptions-item>
              <el-descriptions-item label="所属区域"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.areaName!=''&&assetInfo.areaName!=null">{{
                assetInfo.areaName
              }}</el-descriptions-item>
              <el-descriptions-item label="所属系统"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.systemName!=''&&assetInfo.systemName!=null">{{
                assetInfo.systemName
              }}</el-descriptions-item>
              <el-descriptions-item label="设备类型"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.typeName!=''&&assetInfo.typeName!=null">{{
                assetInfo.typeName
              }}</el-descriptions-item>
              <el-descriptions-item label="设备型号"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.modelName!=''&&assetInfo.modelName!=null">{{
                assetInfo.modelName
              }}</el-descriptions-item>
              <el-descriptions-item label="出厂日期"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.proDate!=''&&assetInfo.proDate!=null">{{
                assetInfo.proDate
              }}</el-descriptions-item>
              <el-descriptions-item label="投用日期"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.useStart!=''&&assetInfo.useStart!=null">{{
                assetInfo.useStart
              }}</el-descriptions-item>
              <el-descriptions-item label="理论寿命（月）"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.life!=''&&assetInfo.life!=null">{{
                assetInfo.life
              }}</el-descriptions-item>
              <el-descriptions-item label="运维开始日期"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.mtcStart!=''&&assetInfo.mtcStart!=null">{{
                assetInfo.mtcStart
              }}</el-descriptions-item>
              <el-descriptions-item label="运维结束日期"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.mtcEnd!=''&&assetInfo.mtcEnd!=null">{{
                assetInfo.mtcEnd
              }}</el-descriptions-item>
              <el-descriptions-item label="设备状态"
                                    :labelStyle='labelStyle'>
                <div style="width: 200px">
                  <el-tag type="success"
                          v-if="assetInfo.state == 1">启用</el-tag>
                  <el-tag type="danger"
                          v-if="assetInfo.state == 2">停用</el-tag>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="停用日期"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.useEnd!=''&&assetInfo.useEnd!=null">{{
                assetInfo.useEnd
              }}</el-descriptions-item>
              <el-descriptions-item label="重点维保"
                                    :labelStyle='labelStyle'>
                <div style="width: 200px">
                  <el-tag v-if="assetInfo.isImportant == 0">否</el-tag>
                  <el-tag type="danger"
                          v-if="assetInfo.isImportant == 1">是</el-tag>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="资产总额"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.price!=''&&assetInfo.price!=null">{{
                assetInfo.price
              }}</el-descriptions-item>
              <el-descriptions-item label="经纬度"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.lnglat!=''&&assetInfo.lnglat!=null">{{ assetInfo.lnglat }}
                <i class="el-icon-location-outline"
                   style="float: right"
                   @click="showMap()"></i></el-descriptions-item>
              <el-descriptions-item label="设备位置"
                                    :labelStyle='labelStyle'
                                    v-if="assetInfo.assetLocation!=''&&assetInfo.assetLocation!=null">{{
                assetInfo.assetLocation
              }}</el-descriptions-item>
            </el-descriptions>

            <el-tabs type="card">
              <el-tab-pane label="生产厂家">
                <el-descriptions :column="3"
                                 style="cursor: pointer; margin-bottom: 12px"
                                 size="mini"
                                 border>
                  <el-descriptions-item label="厂家名称"
                                        :labelStyle='labelStyle'
                                        v-if="assetInfo.manufacturerName!=''&&assetInfo.manufacturerName!=null">{{
                    assetInfo.manufacturerName
                  }}</el-descriptions-item>
                  <el-descriptions-item label="联系人"
                                        :labelStyle='labelStyle'
                                        v-if="assetInfo.manufacturerContactName!=''&&assetInfo.manufacturerContactName!=null">{{
                    assetInfo.manufacturerContactName
                  }}</el-descriptions-item>
                  <el-descriptions-item label="电话"
                                        :labelStyle='labelStyle'
                                        v-if="assetInfo.manufacturerContactPhone!=''&&assetInfo.manufacturerContactPhone!=null">{{
                    assetInfo.manufacturerContactPhone
                  }}</el-descriptions-item>
                  <el-descriptions-item label="地址"
                                        :labelStyle='labelStyle'
                                        v-if="assetInfo.manufacturerAddress!=''&&assetInfo.manufacturerAddress!=null">{{
                    assetInfo.manufacturerAddress
                  }}</el-descriptions-item>
                </el-descriptions>
              </el-tab-pane>
            </el-tabs>

            <template v-if="
                assetInfo.mtcFactoryId != null && assetInfo.mtcFactoryId != 0
              ">
              <el-tabs type="card">
                <el-tab-pane label="维保厂家">
                  <el-descriptions :column="3"
                                   style="cursor: pointer; margin-bottom: 12px"
                                   size="mini"
                                   border>
                    <el-descriptions-item label="厂家名称"
                                          :labelStyle='labelStyle'
                                          v-if="assetInfo.mtcFactoryName!=''&&assetInfo.mtcFactoryName!=null">{{
                      assetInfo.mtcFactoryName
                    }}</el-descriptions-item>
                    <el-descriptions-item label="联系人"
                                          :labelStyle='labelStyle'
                                          v-if="assetInfo.mtcFactoryContactName!=''&&assetInfo.mtcFactoryContactName!=null">{{
                      assetInfo.mtcFactoryContactName
                    }}</el-descriptions-item>
                    <el-descriptions-item label="电话"
                                          :labelStyle='labelStyle'
                                          v-if="assetInfo.mtcFactoryContactPhone!=''&&assetInfo.mtcFactoryContactPhone!=null">{{
                      assetInfo.mtcFactoryContactPhone
                    }}</el-descriptions-item>
                    <el-descriptions-item label="地址"
                                          :labelStyle='labelStyle'
                                          v-if="assetInfo.mtcFactoryAddress!=''&&assetInfo.mtcFactoryAddress!=null">{{
                      assetInfo.mtcFactoryAddress
                    }}</el-descriptions-item>
                  </el-descriptions>
                </el-tab-pane>
              </el-tabs>
            </template>

            <!-- 扩展属性 -->
            <es-extend :extendData="extendData"
                       type="view"></es-extend>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="assetFileList.length > 0 || fileListView.length > 0"
                     label="设备附件"
                     name="second">
          <div v-loading="viewLoading">
            <es-img :info="assetInfo"
                    :fileList="fileListView"
                    type="view"></es-img>
            <div v-if="assetFileList.length > 0">
              <el-divider><span style="color: #409eff">文件附件</span></el-divider>
              <el-table :data="assetFileList"
                        border
                        stripe
                        size="mini"
                        width="100%">
                <el-table-column type="index"
                                 label="序号"
                                 width="50"
                                 align="center">
                </el-table-column>
                <el-table-column prop="name"
                                 width=""
                                 label="文件名称">
                </el-table-column>
                <el-table-column prop="size"
                                 width=""
                                 label="文件大小(KB)">
                  <template slot-scope="scope">
                    {{ (scope.row.size / 1024).toFixed(1) }}
                  </template>
                </el-table-column>
                <el-table-column width="80"
                                 label="操作"
                                 align="center">
                  <template slot-scope="scope">
                    <el-link :underline="false"
                             title="附件"
                             @click="downFile(scope.row)"
                             type="primary"><i class="el-icon-download"></i></el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="
            assetTypeFileList.length > 0 || assetTypeFileListView.length > 0
          "
                     label="设备类型"
                     name="third">
          <div v-loading="viewLoading">
            <es-img :info="assetInfo"
                    :fileList="assetTypeFileListView"
                    type="view"></es-img>
            <div v-if="assetTypeFileList.length > 0">
              <el-divider><span style="color: #409eff">文件附件</span></el-divider>
              <el-table :data="assetTypeFileList"
                        border
                        stripe
                        size="mini"
                        width="100%">
                <el-table-column type="index"
                                 label="序号"
                                 width="50"
                                 align="center">
                </el-table-column>
                <el-table-column prop="name"
                                 width=""
                                 label="文件名称">
                </el-table-column>
                <el-table-column prop="size"
                                 width=""
                                 label="文件大小(KB)">
                  <template slot-scope="scope">
                    {{ (scope.row.size / 1024).toFixed(1) }}
                  </template>
                </el-table-column>
                <el-table-column width="80"
                                 label="操作"
                                 align="center">
                  <template slot-scope="scope">
                    <el-link :underline="false"
                             title="附件"
                             @click="downFile(scope.row)"
                             type="primary"><i class="el-icon-download"></i></el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="assetModelList.length > 0 || assetModelListView.length > 0"
                     label="设备型号"
                     name="fourth">
          <div v-loading="viewLoading">
            <es-img :info="assetInfo"
                    :fileList="assetModelListView"
                    type="view"></es-img>
            <div v-if="assetModelList.length > 0">
              <el-divider><span style="color: #409eff">文件附件</span></el-divider>
              <el-table :data="assetModelList"
                        border
                        stripe
                        size="mini"
                        width="100%">
                <el-table-column type="index"
                                 label="序号"
                                 width="50"
                                 align="center">
                </el-table-column>
                <el-table-column prop="name"
                                 width=""
                                 label="文件名称">
                </el-table-column>
                <el-table-column prop="size"
                                 width=""
                                 label="文件大小(KB)">
                  <template slot-scope="scope">
                    {{ (scope.row.size / 1024).toFixed(1) }}
                  </template>
                </el-table-column>
                <el-table-column width="80"
                                 label="操作"
                                 align="center">
                  <template slot-scope="scope">
                    <el-link :underline="false"
                             title="附件"
                             @click="downFile(scope.row)"
                             type="primary"><i class="el-icon-download"></i></el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer">
        <el-button size="mini"
                   type="primary"
                   @click="viewVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!--设备定位-->
    <el-dialog :visible.sync="setLnglatVisible"
               style="padding-top: 0px">
      <span slot="title">
        <i class="el-icon-location-outline el-icon--left"></i>定位设备
      </span>
      <div id="map"
           class="map-class"></div>
      <span slot="footer">
        <template v-if="editVisible == true">
          <el-button size="mini"
                     @click="setLnglatVisible = false">取 消</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="setLnglat()">确 认</el-button>
        </template>
        <el-button v-if="viewVisible == true"
                   size="mini"
                   type="primary"
                   @click="setLnglatVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import esExtend from "../common/es-extend.vue";
export default {
  components: { esExtend },
  name: "asset",
  props: ["funcs", "paramId"],
  data () {
    return {

      //label样式
      labelStyle: { 'width': '120px' },
      orgTree: [],
      areas: [],
      systems: [],
      types: [],
      factories: [],
      models: [],
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      editVisible: false,
      assetInfo: {}, //设备信息
      rules: {
        //验证条件
        code: [
          { required: true, message: "请输入设备编码", trigger: "blur" },
          { max: 30, message: "不能超过30个字符", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
          { max: 20, message: "不能超过20个字符", trigger: "blur" },
        ],
        orgId: [{ required: true, message: "请选择所属部门", trigger: "blur" }],
        areaId: [
          { required: true, message: "请选择所属区域", trigger: "blur" },
        ],
        systemId: [
          { required: true, message: "请选择所属系统", trigger: "blur" },
        ],
        typeId: [
          { required: true, message: "请选择设备类型", trigger: "blur" },
        ],
        manufacturerId: [
          { required: true, message: "请选择生产厂家", trigger: "blur" },
        ],
        modelId: [
          { required: true, message: "请选择设备型号", trigger: "blur" },
        ],
        state: [{ required: true, message: "请选择设备状态", trigger: "blur" }],
        isImportant: [
          { required: true, message: "请选择是否重点维保", trigger: "blur" },
        ],
      },
      states: [
        { id: 1, name: "启用" },
        { id: 2, name: "停用" },
      ],
      extendMetaData: [],
      extendData: [],
      viewVisible: false,
      loading: false,
      editLoading: false,
      viewLoading: false,
      saving: false,
      url: "",
      fileList: [],
      activeName: "first",
      dialogFileVisible: false,
      assetFileList: [],
      assetModelList: [],
      assetTypeFileList: [],
      assetModelListView: [],
      assetTypeFileListView: [],
      fileListView: [],
      loadingFile: false,
      setLnglatVisible: false,
      AMap: null,
      map: null,
      tempLng: null, //临时经度
      tempLat: null, //临时纬度
    };
  },
  methods: {
    //页面初始化
    init () {
      this.loadSystemListAll();
      this.loadTypeListAll();
      this.loadFactoryListAll();
      this.loadAssetList();
      //弹出详情
      if (this.paramId != null) {
        this.viewVisible = false;
        this.view({ id: this.paramId });
      }
    },

    //将控件数据回写到父类
    insertExtendData (exdata, data) {
      this.assetInfo.extendData = exdata;
      //前台验证使用
      for (let key in data) {
        this.$set(this.assetInfo, key, data[key]);
      }
    },

    initOrgTree (orgTree) {
      this.orgTree = orgTree;
    },

    //初始化系统下拉框
    loadSystemListAll () {
      this.$ajax
        .get("/base/system/list_all")
        .then((msg) => {
          this.systems = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //初始化设备类型下拉框
    loadTypeListAll () {
      this.$ajax
        .get("/base/assettype/list_all")
        .then((msg) => {
          this.types = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //初始化厂家下拉框
    loadFactoryListAll () {
      this.$ajax
        .get("/base/factory/list_all")
        .then((msg) => {
          this.factories = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    //从后台查询设备列表
    loadAssetList () {
      this.loading = true;
      this.$ajax
        .get("/base/asset/list", this.queryObj)
        .then((msg) => {
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },

    //初始化区域下拉框
    loadAreaListAll () {
      let orgid;
      if (this.assetInfo.orgId instanceof Array) {
        orgid = this.$refs.orgId.getCheckedNodes()[0].value;
      } else {
        orgid = this.assetInfo.orgId;
      }

      this.$ajax
        .get("/base/area/list_all", { orgIds: orgid })
        .then((msg) => {
          this.areas = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    //初始化型号下拉框
    loadModelListAll () {
      this.$ajax
        .get("/base/model/list_all", {
          typeId: this.assetInfo.typeId,
          factoryId: this.assetInfo.manufacturerId,
        })
        .then((msg) => {
          this.models = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //初始化自定义列表
    loadExtendListAll (func) {
      this.extendMetaData = [];
      this.extendData = [];
      this.$ajax
        .get("/base/extenddef/listall", {
          typeId: this.assetInfo.typeId,
        })
        .then((msg) => {
          let fathers = [];
          msg.forEach((e) => {
            if (e.dictFatherId != null) {
              fathers.push(e.dictFatherId);
            }
          });
          fathers = Array.from(new Set(fathers));
          if (fathers != null && fathers.length > 0) {
            this.$ajax
              .get("/base/dic/listsonsbyfathers", {
                fathers: fathers.join(","),
              })
              .then((m) => {
                console.log(msg);
                msg.forEach((e) => {
                  if (e.dictFatherId != null) {
                    if (e.dicts == null) {
                      e.dicts = [];
                    }

                    m.forEach((em) => {
                      if (em.father_id == e.dictFatherId) {
                        e.dicts.push(em);
                      }
                    });
                  }
                });
                this.extendMetaData = msg;
                console.log(this.extendMetaData);
                console.log(this.extendData);
                if (func != null) {
                  console.log(2);
                  func();
                }
              })
              .catch((err) => {
                this.$message.error(err);
              });
          } else {
            this.editLoading = false;
            this.extendMetaData = msg;
            if (func != null) {
              func();
            }
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    queryAssetList (orgIds) {
      this.queryObj.pageNum = 1;
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(",");
      }
      this.loadAssetList();
    },

    //初始化添加设备
    add_init () {
      this.extendMetaData = [];
      this.extendData = [];
      this.assetInfo = { state: 1 };
      this.assetInfo = { isImportant: 0 };
      this.editVisible = true;
    },
    //初始化编辑设备
    edit_init (row) {
      this.extendMetaData = [];
      this.extendData = [];
      this.editVisible = true;
      this.editLoading = true;
      this.fileList = [];
      this.$ajax
        .get("/base/asset/load_detail", { id: row.id })
        .then((msg) => {
          this.assetInfo = msg;
          if (msg.longitude != null && msg.latitude != null) {
            this.$set(
              this.assetInfo,
              "lnglat",
              msg.longitude + "," + msg.latitude
            );
          }

          this.loadModelListAll(); //级联的下拉
          this.loadAreaListAll(); //级联的下拉
          this.loadExtendListAll(() => {
            //处理扩展属性
            if (this.extendMetaData != null && this.extendMetaData.length > 0) {
              this.$ajax
                .get("/base/asset/extend_data", {
                  assetId: this.assetInfo.id,
                })
                .then((msg) => {
                  this.extendData = msg;
                  //前台验证使用
                  msg.forEach((e) => {
                    this.$set(
                      this.assetInfo,
                      e.code,
                      e.valueCode != null ? e.valueCode : e.value
                    );
                  });
                })
                .catch((err) => {
                  this.$message.error(err);
                })
                .finally(() => {
                  this.editLoading = false;
                });
            } else {
              this.editLoading = false;
            }
          });
        })
        .catch((err) => {
          this.$message.error(err);
          this.editLoading = false;
        });
    },

    //显示地图
    showMap () {
      this.setLnglatVisible = true;
      this.$ajax
        .get("/buss/home/load_outline_config")
        .then((msg) => {
          AMapLoader.load({
            key: "204899ccad5874a75849e637df77e6ff",
            version: "2.0",
          })
            .then((AMap) => {
              this.AMap = AMap;
              let minizoom =
                msg.oneMapLevelMin == null
                  ? msg.twoMapLevelMin
                  : msg.oneMapLevelMin;
              let center =
                this.assetInfo.lnglat != null &&
                  this.assetInfo.lnglat.split(",").length == 2
                  ? [
                    this.assetInfo.lnglat.split(",")[0],
                    this.assetInfo.lnglat.split(",")[1],
                  ]
                  : [msg.centerLongitude, msg.centerLatitude];
              this.map = new AMap.Map("map", {
                zoom: minizoom,
                center: center,
                zooms: [minizoom, msg.threeMapLevelMax],
              });
              this.tempLng = center[0];
              this.tempLat = center[1];
              if (
                this.assetInfo.lnglat != null ||
                (this.assetInfo.lnglat == null && this.editVisible == true)
              ) {
                let marker = new this.AMap.Marker({
                  position: center,
                  icon: require("../../assets/imgs/location_asset_b_19x31.png"),
                  anchor: "bottom-center",
                  label: { content: this.assetInfo.name, direction: "top" },
                  draggable: this.viewVisible == true ? false : true,
                });
                marker.on("dragend", (p) => {
                  let pixel = new AMap.Pixel(p.pixel.x, p.pixel.y + 15.5);
                  let position = this.map.containerToLngLat(pixel);
                  this.tempLng = position.lng;
                  this.tempLat = position.lat;
                });
                this.map.add(marker);
              }
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //确定定位
    setLnglat () {
      this.setLnglatVisible = false;
      this.assetInfo.lnglat = this.tempLng + "," + this.tempLat;
      this.assetInfo.longitude = this.tempLng;
      this.assetInfo.latitude = this.tempLat;
    },

    //保存设备信息
    submitAsset () {
      this.$refs["assetForm"].validate((valid) => {
        if (valid) {
          this.assetInfo.orgId = this.$refs.orgId.getCheckedNodes()[0].value;
          this.assetInfo.orgName = this.$refs.orgId.getCheckedNodes()[0].label;
          this.assetInfo.areaName = this.$refs.areaSelect.selected.label;
          this.assetInfo.systemName = this.$refs.systemSelect.selected.label;
          this.assetInfo.typeName = this.$refs.typeSelect.selected.label;
          this.assetInfo.manufacturerName =
            this.$refs.manufacturerSelect.selected.label;
          this.assetInfo.modelName = this.$refs.modelSelect.selected.label;
          this.assetInfo.mtcFactoryName =
            this.$refs.mtcFactorySelect.selected.label;

          if (
            this.assetInfo.lnglat == null ||
            this.assetInfo.lnglat.split(",").length != 2
          ) {
            this.assetInfo.longitude = null;
            this.assetInfo.latitude = null;
          } else {
            this.assetInfo.longitude = this.assetInfo.lnglat.split(",")[0];
            this.assetInfo.latitude = this.assetInfo.lnglat.split(",")[1];
          }

          let url = "/base/asset/add";
          if (this.assetInfo.id != null) {
            url = "/base/asset/edit";
          }
          this.saving = true;
          this.$ajax
            .post(url, this.assetInfo)
            .then((msg) => {
              this.saving = false;
              this.loadAssetList();
              this.editVisible = false;
              this.$message.success(msg);
              // if (this.assetInfo.id == null) {
              //   this.$confirm('是否继续添加附件？')
              //     .then(() => {
              //       this.edit_init(this.assetInfo)
              //     })
              //     .catch(() => {
              //       this.editVisible = false
              //       this.$message.success(msg)
              //     });
              // } else {
              //   this.editVisible = false
              //   this.$message.success(msg)
              // }
            })
            .catch((err) => {
              this.$message.error(err);
              this.saving = false;
            });
        }
      });
    },
    //删除设备信息
    del (delId) {
      let ids = [];
      if (delId != null) {
        ids = [delId];
      } else {
        this.$refs["assetTable"].selection.forEach((ele) => {
          ids.push(ele.id);
        });
      }
      if (ids.length > 0) {
        this.loading = true;
        this.$ajax
          .post("/base/asset/delete", { ids: ids })
          .then((msg) => {
            this.loading = false;
            this.$message.success(msg);
            this.queryObj.pageNum = 1; //删除之后，回到第一页
            this.loadAssetList();
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    //查看设备详情
    view (row) {
      this.activeName = "first";
      this.viewVisible = true;
      this.viewLoading = true;
      this.fileListView = [];
      this.assetFileList = [];
      this.assetTypeFileList = [];
      this.assetTypeFileListView = [];
      this.assetModelList = [];
      this.assetModelListView = [];
      this.$ajax
        .get("/base/asset/load_detail", { id: row.id })
        .then((msg) => {
          //初始化图片
          if (msg.attachImgs != null && msg.attachImgs != "") {
            let temp = JSON.parse(msg.attachImgs);
            temp.forEach((e) => {
              this.fileListView.push(
                this.$api +
                e.url +
                "&platform=web&token=" +
                this.$store.getUser().token
              );
            });
          }
          this.assetInfo = msg;
          if (this.assetInfo.attachFiles != null) {
            this.assetFileList = JSON.parse(this.assetInfo.attachFiles);
          }
          if (msg.attachTypeImgs != null && msg.attachTypeImgs != "") {
            let temp = JSON.parse(msg.attachTypeImgs);
            temp.forEach((e) => {
              this.assetTypeFileListView.push(
                this.$api +
                e.url +
                "&platform=web&token=" +
                this.$store.getUser().token
              );
            });
          }
          if (this.assetInfo.attachTypeFiles != null) {
            this.assetTypeFileList = JSON.parse(this.assetInfo.attachTypeFiles);
          }
          if (msg.attachModelImgs != null && msg.attachModelImgs != "") {
            let temp = JSON.parse(msg.attachModelImgs);
            temp.forEach((e) => {
              this.assetModelListView.push(
                this.$api +
                e.url +
                "&platform=web&token=" +
                this.$store.getUser().token
              );
            });
          }
          if (this.assetInfo.attachModelFiles != null) {
            this.assetModelList = JSON.parse(this.assetInfo.attachModelFiles);
          }
          if (msg.longitude != null && msg.latitude != null) {
            this.assetInfo.lnglat = msg.longitude + "," + msg.latitude;
          }
          //加载扩展属性
          this.$ajax
            .get("/base/asset/extend_data", {
              assetId: this.assetInfo.id,
            })
            .then((msg) => {
              this.extendData = msg;
            })
            .catch((err) => {
              this.$message.error(err);
            })
            .finally(() => {
              this.viewLoading = false;
            });
        })
        .catch((err) => {
          this.$message.error(err);
          this.viewVisible = false;
          this.viewLoading = false;
        });
    },
    edit_file (row) {
      this.dialogFileVisible = true;
      this.fileList = [];
      this.assetFileList = [];
      this.$ajax
        .get("/base/asset/load_detail", { id: row.id })
        .then((msg) => {
          //初始化图片
          if (msg.attachImgs != null && msg.attachImgs != "") {
            this.fileList = JSON.parse(msg.attachImgs);
            this.fileList.forEach((e) => {
              e.url =
                this.$api +
                e.url +
                "&platform=web&token=" +
                this.$store.getUser().token;
            });
          }
          this.assetInfo = msg;
          if (this.assetInfo.attachFiles != null) {
            this.assetFileList = JSON.parse(this.assetInfo.attachFiles);
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.editLoading = false;
        });
    },
    downFile (row) {
      this.loadingFile = true;
      const x = new window.XMLHttpRequest();
      x.open(
        "GET",
        this.$api + row.url + "&platform=web&token=" + this.$store.getUser().token,
        true
      );
      x.responseType = "blob";
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement("a");
        a.href = url;
        a.download = row.name;
        a.click();
        this.loadingFile = false;
      };
      x.send();
      this.loadingFile = false;
    },
    beforeUpload (file) {
      this.loadingFile = true;
      const sizeLimit = file.size / 1024 / 1024 > 50;
      if (sizeLimit) {
        this.loadingFile = false;
        this.$message.warning("上传文件大小不能超过 50MB!");
      }
      return !sizeLimit;
    },
    handleSuccess (response, file) {
      console.log(response, file);
      // 存在bug，如果一个页面，同时用两个图片附件
      if (response.code == 200) {
        let tempFileList = new Array();
        if (this.assetInfo.attachFiles != null) {
          tempFileList = JSON.parse(this.assetInfo.attachFiles);
        }
        tempFileList.push({
          name: file.name,
          size: file.size,
          url: "/file/file/down?filename=" + response.msg,
        });
        this.assetInfo.attachFiles = JSON.stringify(tempFileList);
        this.$ajax
          .post("/base/asset/editFile", {
            attachFiles: this.assetInfo.attachFiles,
            id: this.assetInfo.id,
          })
          .then((msg) => {
            if (this.assetInfo.attachFiles != null) {
              this.assetFileList = JSON.parse(this.assetInfo.attachFiles);
            } else {
              this.assetFileList = [];
            }
            this.$message.success(msg);
            this.loadingFile = false;
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } else {
        this.$message.error(response.msg);
      }
    },
    delFile (row) {
      this.loadingFile = true;
      let s = row.url.indexOf("=");
      let e = row.url.length;
      let filename = row.url.substring(s + 1, e);
      let files = JSON.parse(this.assetInfo.attachFiles);
      let newFiles = files.filter((e) => {
        return !e.url.includes(row.url.substring(0, row.url.indexOf(".")));
      });
      let param;
      if (newFiles.length == 0) {
        param = null;
      } else {
        param = JSON.stringify(newFiles);
      }
      //物理删除
      this.$ajax
        .post("/file/file/delete", { fileName: filename })
        .then((msg) => {
          this.assetInfo.attachFiles = JSON.stringify(newFiles);
          this.$ajax
            .post("/base/asset/editFile", {
              attachFiles: param,
              id: this.assetInfo.id,
            })
            .then(() => {
              if (this.assetInfo.attachFiles != null) {
                this.assetFileList = JSON.parse(this.assetInfo.attachFiles);
              } else {
                this.assetFileList = [];
              }
              this.loadingFile = false;
              this.$message.success(msg);
            })
            .catch((err) => {
              this.loadingFile = false;
              this.$message.error(err);
            });
        })
        .catch((err) => {
          this.loadingFile = false;
          this.$message.error(err);
        });
    },


    getUploadAction () {
      return this.$api + "/file/file/upload";
    },
    handleError () {
      this.loadingFile = false;
      this.$message.error("上传附件失败，请确认文件是否超出");
    },
    handleExceed () {
      this.$message.error("超出最大上传附件数");
    },
  },
  mounted () {
    this.init();
  },
};
</script>
<style scoped>
.map-class {
  width: 100%;
  height: 60vh;
}
</style>
